import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { AppActions } from './app/app.actions';
import { ActivityEvent } from '../features/home/models/activity-event.model';

export function createActivityEffect<TActionInput>(
  actions$: Actions,
  action: any,
  activity: ActivityEvent,
  metaResolver?: (input: TActionInput) => any
) {
  return createEffect(() =>
    actions$.pipe(
      ofType(action),
      map((input: TActionInput): Action => {
        const meta = metaResolver ? metaResolver(input) : input;
        return AppActions.AddActivity({ activity, meta });
      })
    )
  );
}
